/* RO cart interactions — the one-time ↔ subscription line swap.
   POST /cart/change.js with {line, quantity, selling_plan}, then
   re-render the drawer + header bubble from the returned sections,
   mirroring Dawn's CartDrawerItems contract exactly. */
(function () {
  'use strict';

  var busy = false;

  function sectionInner(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var el = doc.querySelector(selector);
    return el ? el.innerHTML : null;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ro-swap]');
    if (!btn || busy) return;
    busy = true;
    btn.classList.add('is-busy');
    btn.setAttribute('aria-disabled', 'true');

    var planAttr = btn.getAttribute('data-plan');
    /* Address the line by its key, not its position. A positional index is
       baked in at render time, so if the cart changed without this drawer
       re-rendering, the click would convert whichever line now sits there. */
    var body = {
      id: btn.getAttribute('data-key'),
      quantity: parseInt(btn.getAttribute('data-quantity'), 10),
      selling_plan: planAttr === '' ? null : parseInt(planAttr, 10),
      sections: 'cart-drawer,cart-icon-bubble',
      sections_url: window.location.pathname
    };
    if (!body.id) {
      body.id = undefined;
      body.line = parseInt(btn.getAttribute('data-line'), 10);
    }

    fetch(window.routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (res) { return res.json(); })
      .then(function (state) {
        if (state.status && state.status !== 200) throw new Error(state.message || 'Cart error');
        if (state.sections && state.sections['cart-drawer']) {
          var inner = sectionInner(state.sections['cart-drawer'], '.drawer__inner');
          var target = document.querySelector('#CartDrawer .drawer__inner');
          if (inner && target) target.innerHTML = inner;
        }
        if (state.sections && state.sections['cart-icon-bubble']) {
          var bubble = document.getElementById('cart-icon-bubble');
          var bubbleInner = sectionInner(state.sections['cart-icon-bubble'], '.shopify-section');
          if (bubble && bubbleInner) bubble.innerHTML = bubbleInner;
        }
        var live = document.getElementById('CartDrawer-LiveRegionText');
        if (live) {
          live.textContent = body.selling_plan
            ? 'Item switched to Signature Roasters Club subscription.'
            : 'Item switched to one-time purchase.';
          live.setAttribute('aria-hidden', 'false');
        }
      })
      .catch(function () {
        var err = document.getElementById('CartDrawer-CartErrors');
        if (err) err.textContent = 'Something went wrong updating your cart. Please try again.';
      })
      .finally(function () {
        busy = false;
        /* On success the drawer re-renders and this button is replaced, but on
           failure it survives — and the error copy asks the visitor to retry
           with the very control we would otherwise leave disabled. */
        btn.classList.remove('is-busy');
        btn.removeAttribute('aria-disabled');
      });
  });
})();
